import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";
import { FooterMountainsComponent } from "./footer-mountains/footer-mountains.component";
import { PlanCardFromPlanComponent } from "./plan-card/plan-card-from-plan.component";
import { FooterMenuComponent } from "./footer-menu/footer-menu.component";
import { PageTitleComponent } from "./page-title/page-title.component";
import { FullOrderCardComponent } from "./order-card-with-map/full-order-card.component";
import { ReferralCodeComponent } from "./referral-code/referral-code.component";
import { CreditCardComponent } from "./credit-card/credit-card.component";
import { MapComponent } from "./map/map.component";
import { OrderTimeSelectComponent } from "./order-time-select/order-time-select.component";
import { LogInWithSocialsButtonsComponent } from "./login-with-socials-buttons/log-in-with-socials-buttons.component";
import { PlanCardFromSubscriptionComponent } from "./plan-card/plan-card-from-subscription.component";
import { HighlightSearchPipe } from "../../highlight-search.pipe";
import { ItemListComponent } from "./item-list/item-list.component";
import { ScannerComponent } from "./scanner/scanner.component";
import { ModalHeaderComponent } from "./modal-header/modal-header.component";
import { QrCodeComponent } from "./qr-code/qr-code.component";
import { RackScannerComponent } from "./scanner/rack-scanner/rack-scanner.component";
import { ScanRackModalComponent } from "./scanner/rack-scanner/modal/scan-rack-modal.component";
import { ItemStatusIconComponent } from "./item-list/item-status-icon/item-status-icon.component";
import { ItemScannerComponent } from "./scanner/item-scanner/item-scanner.component";
import { ScanItemModalComponent } from "./scanner/item-scanner/modal/scan-item-modal.component";
import { ItemInListComponent } from "./item-list/item-in-list/item-in-list.component";
import { AddToCalendarButtonComponent } from "./add-to-calendar-button/add-to-calendar-button.component";
import { ItemHistoryListComponent } from "./history-list/item/item-history-list.component";
import { OrderHistoryListComponent } from "./history-list/order/order-history-list.component";
import { UploadPictureComponent } from "./upload-picture/upload-picture.component";
import { ClickableThumbnailComponent } from "./clickable-thumbnail/clickable-thumbnail.component";
import { FullScreenPictureModalComponent } from "./clickable-thumbnail/modal/full-screen-picture-modal.component";
import { DateFormFieldComponent } from "./form-field/date-form-field/date-form-field.component";
import { DriverFormFieldComponent } from "./form-field/search-form-field/driver-form-field/driver-form-field.component";
import { DriverSearchResultComponent } from "./form-field/search-form-field/driver-form-field/driver-search-result.component";
import { ItemStatusFormFieldComponent } from "./form-field/item-status-form-field/item-status-form-field.component";
import { LocationFormFieldComponent } from "./form-field/location-form-field/location-form-field.component";
import { PasswordFormFieldComponent } from "./form-field/password-form-field/password-form-field.component";
import { MultiSelectFormFieldComponent } from "./form-field/select-form-field/multi-select-form-field/multi-select-form-field.component";
import { OrderPreferencesFormFieldComponent } from "./form-field/order-preferences-form-field/order-preferences-form-field.component";
import { OrderStatusFormFieldComponent } from "./form-field/order-status-form-field/order-status-form-field.component";
import { OrderTimeFormFieldComponent } from "./form-field/order-time-form-field/order-time-form-field.component";
import { RackFormFieldComponent } from "./form-field/rack-form-field/rack-form-field.component";
import { ServiceTypeFormFieldComponent } from "./form-field/service-type-form-field/service-type-form-field.component";
import { SignUpFormComponent } from "../kiosk/pages/kiosk-sign-up/sign-up-form/sign-up-form.component";
import { SingleSelectFormFieldComponent } from "./form-field/select-form-field/single-select-form-field/single-select-form-field.component";
import { StringFormFieldComponent } from "./form-field/string-form-field/string-form-field.component";
import { UserFormFieldComponent } from "./form-field/search-form-field/user-form-field/user-form-field.component";
import { UserSearchResultComponent } from "./form-field/search-form-field/user-form-field/user-search-result.component";
import { ItemStatusBadgeComponent } from "./badges/item-status-badge/item-status-badge.component";
import { OrderStatusBadgeComponent } from "./badges/order-status-badge/order-status-badge.component";
import { PaymentStatusBadgeComponent } from "./badges/payment-status-badge/payment-status-badge.component";
import { ServiceTypeBadgeComponent } from "./badges/service-type-badge/service-type-badge.component";
import { OrderStepBadgeComponent } from "./badges/order-step-badge/order-step-badge.component";
import { OrderStepFormFieldComponent } from "./form-field/order-step-form-field/order-step-form-field.component";
import { MultiLineStringFormFieldComponent } from "./form-field/multi-line-string-form-field/multi-line-string-form-field.component";
import { OrderTableComponent } from "./tables/order/order-table.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { VehicleScannerComponent } from "./scanner/vehicle-scanner/vehicle-scanner.component";
import { OrderUserInfoComponent } from "./order-card-with-map/order-user-info.component";
import { OrderStatusesComponent } from "./order-card-with-map/order-statuses.component";
import { ItemGridComponent } from "./item-grid/item-grid.component";
import { OrderTableContextMenuComponent } from "./tables/order/order-table-context-menu.component";
import { DimensionFormFieldComponent } from "./form-field/dimension-form-field/dimension-form-field.component";
import { ItemTableComponent } from "./tables/item/item-table.component";
import { MobileOrderTableComponent } from "./tables/order/mobile-order-table.component";
import { UserTableComponent } from "./tables/user/user-table.component";
import { OrderFeesFormComponent } from "../../pages/admin/order-fees/form/order-fees-form.component";
import { PinchZoomComponent } from "@meddv/ngx-pinch-zoom";
import { TransactionTableComponent } from "./tables/transaction/transaction-table.component";
import { RewardsSectionComponent } from "../../pages/admin/components/rewards-section/rewards-section.component";
import { CdnImgComponent } from "./cdn-img/cdn-img.component";
import { AuditLogListComponent } from "./audit-log-list/audit-log-list.component";

const badgesComponents = [
  ItemStatusBadgeComponent,
  OrderStatusBadgeComponent,
  OrderStepBadgeComponent,
  PaymentStatusBadgeComponent,
  ServiceTypeBadgeComponent,
];

const formFieldComponents = [
  DateFormFieldComponent,
  DimensionFormFieldComponent,
  DriverFormFieldComponent,
  DriverSearchResultComponent,
  ItemStatusFormFieldComponent,
  LocationFormFieldComponent,
  MobileOrderTableComponent,
  MultiLineStringFormFieldComponent,
  MultiSelectFormFieldComponent,
  OrderFeesFormComponent,
  OrderPreferencesFormFieldComponent,
  OrderStatusFormFieldComponent,
  OrderStepFormFieldComponent,
  OrderTableComponent,
  OrderTableContextMenuComponent,
  OrderTimeFormFieldComponent,
  PasswordFormFieldComponent,
  RackFormFieldComponent,
  ServiceTypeFormFieldComponent,
  SignUpFormComponent,
  SingleSelectFormFieldComponent,
  StringFormFieldComponent,
  UserFormFieldComponent,
  UserSearchResultComponent,
  UserTableComponent,
];

const declarationsAndExports = [
  AddToCalendarButtonComponent,
  AuditLogListComponent,
  CdnImgComponent,
  ClickableThumbnailComponent,
  CreditCardComponent,
  FullOrderCardComponent,
  FooterMenuComponent,
  FooterMountainsComponent,
  FullScreenPictureModalComponent,
  HighlightSearchPipe,
  ItemGridComponent,
  ItemHistoryListComponent,
  ItemInListComponent,
  ItemListComponent,
  ItemScannerComponent,
  ItemStatusIconComponent,
  ItemTableComponent,
  LogInWithSocialsButtonsComponent,
  MapComponent,
  ModalHeaderComponent,
  OrderHistoryListComponent,
  OrderStatusesComponent,
  OrderTimeSelectComponent,
  OrderUserInfoComponent,
  PageTitleComponent,
  PlanCardFromSubscriptionComponent,
  PlanCardFromPlanComponent,
  QrCodeComponent,
  RackScannerComponent,
  ReferralCodeComponent,
  RewardsSectionComponent,
  ScannerComponent,
  ScanItemModalComponent,
  ScanRackModalComponent,
  TransactionTableComponent,
  UploadPictureComponent,
  VehicleScannerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    PinchZoomComponent,
  ],
  declarations: [...badgesComponents, ...formFieldComponents, ...declarationsAndExports],
  exports: [...badgesComponents, ...formFieldComponents, ...declarationsAndExports],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedComponentsModule {}
